import { Action } from "redux";

/**
 * A Payload which may have an error attached to it.
 *
 * @export
 * @interface ErrorPayload
 */
export interface ErrorPayload {
    error?: Error;
}

/**
 * An END action for Admin related actions.
 *
 * @export
 * @interface AdminAction
 * @extends {Action}
 * @template T
 */
export interface AdminEndAction<T extends ErrorPayload> extends Action {
    payload: T;
}